// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/" + {"1561": "731eb6b5881bd34a","1715": "ee66b727ce89ed49","3727": "c90dba5c0a27ec0c","4037": "c889908a9eb7b3ec","924": "39fd1b59e76129a8",}[chunkId] + ".css"
}